export default __webpack_public_path__ + "static/media/store_svg2.a288fff4.svg";